const colors = () => JSON.parse(window?.config?.REACT_APP_JSON_COLORS);
const themeLigth = () => JSON.parse(window?.config?.REACT_APP_JSON_THEMELIGHT);
const themeDark = () => JSON.parse(window?.config?.REACT_APP_JSON_THEMEDARK);

export { colors, themeLigth, themeDark };
